import { queryURLparams } from '@/utils';
import { IQuery } from '@/utils/const';
import { localMemory } from 'localmemory';
import { create } from 'zustand';

interface ISessionConfig {
  nickId: string;
  uid: string;
  token: string;
  sessionId: string;
}

interface IUserStore {
  sessionConfig: ISessionConfig;
  userReplyCountdown: number;
  replyCountdownRef: any;
  sendCount: number;
  setUserReplyCountdown: (time: number) => void;
  setSessionConfig: (sessionConfig: ISessionConfig) => void;
  setReplyCountdownRef: (target: any) => void;
  setSendCount: () => void;
  getSessionConfig: () => ISessionConfig;
}

/**
 * session config localStorage cache
 */
export const sessionConfigCache = () => {
  const query = queryURLparams<IQuery>();
  const nickId = query?.nickId || '';

  const setSessionConfig = (sessionConfig: ISessionConfig) => {
    if (nickId) {
      localMemory.setItem({ name: `user-${nickId}`, value: sessionConfig });
    } else {
      localMemory.setItem({ name: `visitor`, value: sessionConfig });
    }
  };

  const getSessionConfig = (): { sessionConfig: ISessionConfig } => {
    let _sessionConfig: ISessionConfig;
    if (nickId) {
      _sessionConfig = localMemory.getItem(`user-${nickId}`);
    } else {
      _sessionConfig = localMemory.getItem(`visitor`);
    }

    return {
      sessionConfig: _sessionConfig || {
        nickId: '',
        uid: '',
        token: '',
        sessionId: '',
      },
    };
  };

  return {
    nickId,
    getSessionConfig,
    setSessionConfig,
  };
};

const useUserStore = create<IUserStore>((set, get) => ({
  sessionConfig: {
    nickId: '',
    uid: '',
    token: '',
    sessionId: '',
  },

  setSessionConfig: (sessionConfig: ISessionConfig) =>
    set(() => {
      const { setSessionConfig } = sessionConfigCache();
      setSessionConfig(sessionConfig);
      return { sessionConfig };
    }),

  sendCount: 0,
  setSendCount: () => set((state) => ({ sendCount: state.sendCount + 1 })),

  userReplyCountdown: 0,
  setUserReplyCountdown: (time: number) =>
    set(() => {
      return { userReplyCountdown: time };
    }),

  replyCountdownRef: null,
  setReplyCountdownRef: (target: any) => {
    set(() => {
      return { replyCountdownRef: target };
    });
  },
  getSessionConfig: () => {
    return get().sessionConfig;
  },
}));

export default useUserStore;
